class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;

    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.content;

    const enter = this._onEnter.bind(this);
    const leave = this._onLeave.bind(this);

    // summary.addEventListener('mouseenter', enter);
    // summary.addEventListener('mouseleave', leave);

    // if (content) {
    //   content.addEventListener('mouseenter', enter);
    //   content.addEventListener('mouseleave', leave);
    // }
  }

  // Disable focus-based closing — hover handles open/close.
  onFocusOut() {}

  _onEnter() {
    clearTimeout(this._closeTimer);
    this._closeTimer = null;

    // Close any other open header menus immediately.
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu._closeNow();
    });

    this.mainDetailsToggle.open = true;
  }

  _onLeave() {
    this._closeTimer = setTimeout(() => this.close(), 150);
  }

  _closeNow() {
    clearTimeout(this._closeTimer);
    this._closeTimer = null;
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    clearTimeout(this._closeTimer);
    this._closeTimer = null;
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
